import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'

const title = 'Restrictions'
const headers = {
  icon: 'feather icon-credit-card',
  title: title,
  description: 'track and manage all restrictions information',
}

export default function RestrictionPage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          { label: 'Title', field: 'title' },
          { label: 'Code', field: 'code' },
          { label: 'Type', field: 'type' },
          // { label: 'Total', field: 'total' },
          { label: 'Mode', field: 'mode' },
          {
            label: 'Client name',
            field: 'client',
            render: ['name'],
          },
          {
            label: 'Description',
            field: 'description',
          },
        ]}
        resource={resources.cardPermission}
        title={title}
        link="/water_cards/restrictions"
      />
    </MainPage>
  )
}
